import { getAccessToken, isTokenExpired } from "./api";

const baseUrl = process.env.REACT_APP_API_URL;
const VISITOR_ID_KEY = "ibt-anonymous-visitor-id";

const createVisitorId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join(
      "",
    );
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const getAnonymousVisitorId = () => {
  let visitorId = localStorage.getItem(VISITOR_ID_KEY);

  if (!visitorId) {
    visitorId = createVisitorId();
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }

  return visitorId;
};

export const trackPageView = async (path) => {
  if (!baseUrl || typeof fetch !== "function") return;

  try {
    const accessToken = getAccessToken();
    const headers = {
      "Content-Type": "application/json",
    };

    if (accessToken && !isTokenExpired(accessToken)) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    const requestOptions = {
      method: "POST",
      headers,
      body: JSON.stringify({
        visitor_id: getAnonymousVisitorId(),
        path,
      }),
      keepalive: true,
    };
    const response = await fetch(baseUrl + "metrics/page-view/", requestOptions);

    // 비밀번호 변경 등으로 토큰이 서버에서 폐기된 경우에도 방문 자체는 익명 집계합니다.
    if (response.status === 401 && headers.Authorization) {
      const anonymousHeaders = { ...headers };
      delete anonymousHeaders.Authorization;
      await fetch(baseUrl + "metrics/page-view/", {
        ...requestOptions,
        headers: anonymousHeaders,
      });
    }
  } catch {
    // 통계 전송 실패가 사용자의 답안 작성 흐름을 방해해서는 안 됩니다.
  }
};
